import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../components/LoginButton';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();

  const handleLogin = (e) => {
    e.preventDefault();

    localStorage.setItem('user', JSON.stringify({ email }));
    localStorage.setItem('mealsToken', '1');
    localStorage.setItem('cocktailsToken', '1');
    history.push('/foods');
  };

  const emailRegex = /\S+@\S+\.\S+/;
  const MIN_PASSWORD_LENGTH = 6;
  return (
    <div className="login-page">
      <h1 className="l-title">
        Mes
        <br />
        &nbsp; Recettes
      </h1>
      <form onSubmit={ handleLogin } className="l-form">
        <input
          type="email"
          placeholder="Email"
          className="l-input"
          value={ email }
          data-testid="email-input"
          onChange={ (e) => setEmail(e.target.value) }
        />
        <input
          type="password"
          placeholder="Password"
          className="l-input"
          value={ password }
          data-testid="password-input"
          onChange={ (e) => setPassword(e.target.value) }
        />

        <Button
          type="submit"
          className="l-button"
          disabled={
            !(emailRegex.test(email) && password.length > MIN_PASSWORD_LENGTH)
          }
          text="Login"
          testId="login-submit-btn"
        />

      </form>
    </div>
  );
}
export default Login;
